import React, {PureComponent, ReactNode} from "react";
import {MapContainer, Marker, TileLayer} from "react-leaflet";
import L from "leaflet";
import {renderToStaticMarkup} from "react-dom/server";
import {MapLocationIcon} from "@App/components/GarageList/Map/GarageListMap";
import {Garage} from "@App/types";
import google from "@App/public/assets/images/google.png";


export type GarageProfileMapProps = {
    garage: Garage
};

export class GarageProfileMap extends PureComponent<GarageProfileMapProps> {

    render(): ReactNode {
        const {
            garage,
        } = this.props

        return (
            <MapContainer center={{lat: garage ? garage.lat : 48.137154, lng: garage ? garage.lon : 11.576124}}
                          zoom={11} scrollWheelZoom={false} style={{'width': '100%', 'height': '100%'}}>
                <TileLayer
                    subdomains={['mt0', 'mt1', 'mt2', 'mt3']}
                    maxZoom={20}
                    attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
                    url="http://{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}"
                />
                <Marker position={[(garage ? garage.lat : 48.137154), (garage ? garage.lon : 11.576124)]}
                        icon={L.divIcon({
                            html: renderToStaticMarkup(<MapLocationIcon/>)
                        })}/>
                <div className={'copyright absolute bottom-2 left-2 z-[9999]'}>
                    <img src={google.src} alt={'Google'}/>
                </div>
            </MapContainer>
        )
    }

}

export default GarageProfileMap

